<template>
  <v-snackbar
    v-model="control"
    :color="color"
    :timeout="timeout"
    location="top"
  >
    {{ text }}

    <template #actions>
      <v-btn
        variant="text"
        icon="mdi-close"
        @click="control = false"
      ></v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { storeToRefs } from "pinia";
import snackbarStore from "@/store/snackbar";

const snackbar = snackbarStore();
const { text, timeout, color, control } = storeToRefs(snackbar);
</script>
